module.exports = __webpack_public_path__ + "img/pattern.9f54d43c.webp";